import axios, { AxiosError, AxiosInstance } from 'axios'
import type { APIError } from '@shared/types/api'
import { setApiClient, toAPIError } from '@shared/api/client'
import { handleMiniAppStaleSession, miniAppAuthHeaders } from '@shared/api/miniAppAuth'

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8080/api/v1'

// Создаем axios instance
const apiClient: AxiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 120000, // 2 минуты для операций с LLM (импорт спортсменов)
})

// Request interceptor - init data мини-приложения для аутентификации:
// X-Telegram-Init-Data в Telegram, X-Max-Init-Data в MAX (не оба сразу)
apiClient.interceptors.request.use(
  (config) => {
    for (const [name, value] of Object.entries(miniAppAuthHeaders())) {
      config.headers[name] = value
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor - обработка ошибок. Редиректа на логин нет (авторизация
// через Init Data), ошибка уходит вызывающему как APIError. 401 - init data
// больше не принимается: один раз просим открыть приложение заново
// (Telegram - showAlert, MAX - своё окно, в мосте MAX его нет).
apiClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError<APIError>) => {
    if (error.response?.status === 401) {
      handleMiniAppStaleSession()
    }
    return Promise.reject(toAPIError(error))
  }
)

// Register with shared package so all API modules use this instance
setApiClient(apiClient)

export default apiClient
